import { connect } from 'react-redux';
import CommissionDetails, { ACTION_TYPES } from "./CommissionDetails";
import { getTranslation } from "../../../reducers/common/localization";
import {
    getCurrentContinent,
    getContinentsData,
    getCountriesData,
    setCurrentContinent
} from '../../../reducers/common/location';
import {
    fetchGetBAsList,
    getBAsList,
    loadingBAsList,
    getCurrentCommissionDataFormatted,
    loadingCurrentCommission,
    fetchGetCommissionData,
    fetchUpdateCommission
} from '../../../reducers/commission/commissions';
import { getSubmitFormSuccessStatus } from '../../../reducers/common/submitForm';
import { Utils } from "../../../utils/utils";

const mapStateToProps = (state, { location }) => {
    let pathParams = Utils.getParamsFromLocationSearch(location.search);
    return {
        id: pathParams.id,
        baId: pathParams.baId,
        translation: getTranslation(state),
        actionType: ACTION_TYPES.EDIT,
        data: getCurrentCommissionDataFormatted(state),
        currentContinent: getCurrentContinent(state),
        continents: getContinentsData(state),
        countries: getCountriesData(state),
        loading: loadingBAsList(state) || loadingCurrentCommission(state),
        BAsList: getBAsList(state),
        success: getSubmitFormSuccessStatus(state)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onGetCommissionData: (baId, commissionId) => {
            dispatch(fetchGetCommissionData(baId, commissionId))
        },
        onGetBAsList: () => {
            dispatch(fetchGetBAsList())
        },
        onSetContinent: (continentCode) => {
            dispatch(setCurrentContinent(continentCode))
        },
        onProcess: (baId, commissionId, data) => {
            dispatch(fetchUpdateCommission(baId, commissionId, data))
        },
        onUnmount: () => {
            dispatch(setCurrentContinent(""));
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(CommissionDetails);



// WEBPACK FOOTER //
// ./src/components/paymentManagement/commissionDetails/EditCommission.container.js